export const FAQ_ITEMS = [
  {
    question: '誰でも紹介できますか？',
    answer:
      'はい、どなたでもご紹介いただけます。よく行くお店、友人・知人のお店、地元の店舗など、「荷物を預けられそう」と思った場所を自由にご紹介ください。ご自身が運営する店舗の場合は「店舗として応募する」からお申し込みいただけます。',
  },
  {
    question: '紹介報酬の15,000円・導入特典の10,000円は、いつ支払われますか？',
    answer:
      '紹介いただいた店舗・施設が ecbo cloak を導入し、以下の条件を満たしたことを確認できた後にお支払いします。\n\n【お支払い条件】\n・2ヶ月間継続して掲載されていること\n・その間に予約不成立がないこと\n\n条件達成の確認後、紹介者の方に15,000円、導入された店舗・施設に10,000円をお渡しします。お支払い方法は個別でご案内します。',
  },
  {
    question: '紹介できる店舗数に上限はありますか？',
    answer:
      '上限はありません。複数の店舗をご紹介いただいた場合、掲載開始に至った店舗の数だけ紹介報酬をお受け取りいただけます。',
  },
  {
    question: '紹介した店舗は必ず導入されますか？',
    answer:
      'ご紹介後、ecbo担当者が店舗・施設へご連絡し、立地・スペース・運用体制などを確認のうえ導入可否を判断します。すべての店舗が導入に至るとは限らない点はご了承ください。報酬は掲載開始が確認できた場合にお支払いします。',
  },
  {
    question: 'どのような業態が登録できますか？',
    answer:
      'カフェ、居酒屋・飲食店、美容室、ネイルサロン、ゲストハウス、コワーキングスペースをはじめ、神社などのユニークなスペースの登録も増えています。駅・観光地・イベント会場の近くで、荷物を管理できるスタッフが常駐している店舗が向いています。',
  },
  {
    question: 'スペースがほとんどなくても導入できますか？',
    answer:
      '「受け入れる荷物数は3つまで」など、受け入れ可能数を事前に設定いただけます。設定数を超える予約は入らないため、スペースの大きさに合わせて無理なく預かっていただけます。',
  },
  {
    question: '導入に費用はかかりますか？',
    answer:
      '店舗・施設のオーナーさまからは1円も請求いたしません。ユーザーの利用料金から手数料を引いた金額を、収益としてお支払いします。導入のための初期費用・月額費用もかかりません。',
  },
  {
    question: 'オペレーションは大変ではないですか？',
    answer:
      '必要な作業は、お客さまの来店を確認次第、荷物の写真を撮っていただくだけです。30秒程度で完了するため、本業が忙しい店舗でもスムーズにご利用いただけます。ブラウザに加え、専用アプリもご用意しています。',
  },
  {
    question: '荷物の紛失・破損が心配です。',
    answer:
      '万が一、お客さまの荷物の紛失・破損・盗難等が起きた場合でも保険が適用されるため、安心して荷物をお預かりいただけます。',
  },
  {
    question: '外国語の対応に不安がありますが大丈夫ですか？',
    answer:
      '店舗でしていただくことは写真撮影のみのため、言語のコミュニケーションができなくても対応可能です。言語対応ができれば、その分だけ営業のチャンスも広がります。',
  },
  {
    question: 'キャンペーンの期間はいつまでですか？',
    answer:
      '終了日は定めていませんが、総額1億円の予算がなくなり次第、終了となります。また、本キャンペーンは予告なく終了、または内容を変更する場合がありますので、あらかじめご了承ください。',
  },
]
